(function () {
  'use strict';

  function initLookbookOverlays(container) {
    var items = container.querySelectorAll('.lookbook-item--has-overlay');

    items.forEach(function (item) {
      var trigger = item.querySelector('.lookbook-item__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isActive = item.classList.contains('is-active');

        // 他を閉じる
        items.forEach(function (other) {
          other.classList.remove('is-active');
        });

        // 自分をトグル
        if (!isActive) {
          item.classList.add('is-active');
        }
      });
    });

    // 外側クリックで閉じる
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lookbook-item--has-overlay')) {
        items.forEach(function (item) {
          item.classList.remove('is-active');
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.custom-grid-section').forEach(initLookbookOverlays);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.custom-grid-section');
      if (section) initLookbookOverlays(section);
    });
  }
})();
